/*
    Developer's battery info page
*/

import React, { Component } from 'react';
import Dashboard from '../dashboard';
import styles from '../../style/info-card.module.css';
import { connect } from 'react-redux';
import axios from 'axios';
import { Input, Modal } from 'antd';
import { DeleteOutlined, EditOutlined, RollbackOutlined, SaveOutlined } from '@ant-design/icons';

class BatteryInfoPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // battery info
      batteryID: props.match.params.batteryID,
      batteryInfo: {
        name: ''
      },

      // flags
      isEditing: false
    };
  }

  componentDidMount() {
    this.getBatteryInfo();
  }

  endEditing = () => {
    this.setState({
      isEditing: false
    });

    this.getBatteryInfo();
  };

  deleteBattery = () => {
    return new Promise((resolve, reject) => {
      axios
        .delete(process.env.REACT_APP_API_URL + '/battery/delete', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Token ' + this.props.token
          },
          data: {
            batteryID: this.state.batteryID
          }
        })
        .then((response) => {
          this.props.history.replace('/developer/batteries');
          resolve();
        })
        .catch((error) => {
          console.log(error);
        });
    }).catch((error) => {
      console.log(error);
    });
  };

  getBatteryInfo = () => {
    const data = {
      batteryID: this.state.batteryID
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    return axios
      .post(process.env.REACT_APP_API_URL + '/battery/get', data, config)
      .then((response) => {
        // check to make sure a data object was returned
        if (response.data == null) throw new Error('no response data');

        this.setState({
          batteryInfo: {
            name: response.data.battery.name
          }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleBatteryInfoChange = (event) => {
    const { name, value } = event.target;

    this.setState((state) => ({
      batteryInfo: {
        ...state.batteryInfo,
        [name]: value
      }
    }));
  };

  // sends the current state of batteryInfo to the API
  editBatteryInfo = () => {
    const data = {
      batteryID: this.state.batteryID,
      name: this.state.batteryInfo.name
    };

    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Token ' + this.props.token
      }
    };

    return axios
      .patch(process.env.REACT_APP_API_URL + '/battery/edit', data, config)
      .then((response) => {
        this.endEditing();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  showDeleteConfirm = () => {
    let deleteBattery = this.deleteBattery;
    Modal.confirm({
      cancelText: 'Cancel',
      content: 'This can not be undone!',
      maskClosable: true,
      okButtonProps: { type: 'danger' },
      okText: 'Delete',
      onCancel() {},
      onOk() {
        deleteBattery();
      },
      title: 'Are you sure you want to delete this battery?'
    });
  };

  render() {
    return (
      <Dashboard>
        <div className={styles['card']}>
          <div className={styles['header']}>
            <label className={styles['name']}>
              {this.state.batteryInfo.name ? this.state.batteryInfo.name : null}
            </label>
            {
              // cancel button
              this.state.isEditing ? (
                <div className={styles['button-container']} onClick={this.endEditing}>
                  <RollbackOutlined />
                  <label className={styles['header-button-label']}>cancel</label>
                </div>
              ) : null
            }
            {
              // save button
              this.state.isEditing ? (
                <div className={styles['button-container']} onClick={this.editBatteryInfo}>
                  <SaveOutlined />
                  <label className={styles['header-button-label']}>Save</label>
                </div>
              ) : null
            }
            {!this.state.isEditing ? (
              <div className={styles['button-container']} onClick={() => this.showDeleteConfirm()}>
                <DeleteOutlined />
                <label className={styles['header-button-label']}>Delete</label>
              </div>
            ) : null}
            {!this.state.isEditing ? (
              <div
                className={styles['button-container']}
                onClick={() =>
                  this.setState({
                    isEditing: true
                  })
                }
              >
                <EditOutlined />
                <label className={styles['header-button-label']}>Edit</label>
              </div>
            ) : null}
          </div>
          <hr className={styles['horizontal-line']}></hr>
          <div className={styles['info-container']}>
            <div className={styles['item-container']}>
              <label className={styles['item-name']}>Name</label>
              <Input
                className={styles['item-string']}
                name="name"
                onChange={this.handleBatteryInfoChange}
                onPressEnter={(e) => e.target.blur()}
                readOnly={!this.state.isEditing}
                value={this.state.batteryInfo.name}
              />
              <hr className={styles['item-underline']}></hr>
            </div>
          </div>
        </div>
      </Dashboard>
    );
  }
}

const mapStateToProps = (state) => ({
  token: state.token
});

export default connect(mapStateToProps, null)(BatteryInfoPage);
